import {RouteRecordRaw} from 'vue-router';
import {Role} from '../../../records/user.record';

export default function (rootName: string): RouteRecordRaw[] {
    return [
        {
            path: `driver/:performerId`,
            name: `${rootName}DriverForm`,
            component: () => import('../../settings/drivers/DriverForm.vue'),
            props: (route) => {
                return Object.assign({
                    performerId: route.params.performerId != 'add' ? route.params.performerId : null,
                    snapshot: rootName != 'drivers',
                    backRouteName: rootName,
                    date: route.query.date ? Number(route.query.date) : null
                });
            },
            meta: {
                roles: [Role.DISPATCHER, Role.ADMIN, Role.CUSTOMER_SERVICE]
            }
        }
    ];
}
